import { Comment } from "../../models/comment";

export const mockedWorkordersComments: Comment[] = [
  {
    code: "ACCP",
    statusCode: "A",
    name: "Cette requête exige une analyse ou une planification approfondie. Le délai de réalisation pourrait varier",
  },
  {
    code: "APLA",
    statusCode: "F",
    name: null,
  },
  {
    code: "CAN",
    statusCode: "C",
    name: null,
  },
  {
    code: "COUR",
    statusCode: "V",
    name: null,
  },
  {
    code: "CREE",
    statusCode: "P",
    name: null,
  },
  {
    code: "PLAN",
    statusCode: "L",
    name: null,
  },
  {
    code: "RDDS",
    statusCode: "R",
    name: "La situation signalée diffère de celle constatée sur les lieux. Le délai de réalisation pourrait varier",
  },
  {
    code: "REAC",
    statusCode: "E",
    name: null,
  },
  {
    code: "REFUS0",
    statusCode: "X",
    name: null,
  },
  {
    code: "REFUS1",
    statusCode: "X",
    name: "L'entretien de ce lampadaire relève de la responsabilité d'Hydro-Québec",
  },
  {
    code: "REFUS10",
    statusCode: "X",
    name: "Collecte de branches inapplicable : branches attachées",
  },
  {
    code: "REFUS11",
    statusCode: "X",
    name: "Collecte de branches inapplicable : branches non déposées en bordure de rue",
  },
  {
    code: "REFUS12",
    statusCode: "X",
    name: "Collecte de branches inapplicable : le diamètre excède 20 cm",
  },
  {
    code: "REFUS13",
    statusCode: "X",
    name: "Collecte de branches inapplicable : branches d'un arbre abattu; sous la responsabilité d'un entrepreneur privé",
  },
  {
    code: "REFUS14",
    statusCode: "X",
    name: "Cette requête relève de la responsabilité de Bell",
  },
  {
    code: "REFUS15",
    statusCode: "X",
    name: "Cette requête relève du domaine privé (hors du domaine d'intervention de la Ville)",
  },
  {
    code: "REFUS16",
    statusCode: "X",
    name: "Après vérification, nous avons constaté que les rues et les trottoirs sont sécuritaires",
  },
  {
    code: "REFUS17",
    statusCode: "X",
    name: "Manque ou peu d'information pour susciter l'intervention de la Ville",
  },
  {
    code: "REFUS18",
    statusCode: "X",
    name: "La demande concerne une ruelle",
  },
  {
    code: "REFUS19",
    statusCode: "X",
    name: "Cette demande ne peut être traitée à cause de la configuration des lieux",
  },
  {
    code: "REFUS2",
    statusCode: "X",
    name: "Cette requête relève de la responsabilité de la Société de transport de Montréal (STM)",
  },
  {
    code: "REFUS3",
    statusCode: "X",
    name: "Cette requête relève de la responsabilité d'un établissement d'enseignement",
  },
  {
    code: "REFUS4",
    statusCode: "X",
    name: "Cette requête relève de la responsabilité du ministère des Transports",
  },
  {
    code: "REFUS5",
    statusCode: "X",
    name: "Cette requête relève de la responsabilité d'un organisme autre que la Ville de Montréal",
  },
  {
    code: "REFUS6",
    statusCode: "X",
    name: "Après vérification, nous n'avons pas constaté de problème à l'emplacement indiqué",
  },
  {
    code: "REFUS7",
    statusCode: "X",
    name: "Collecte de branches inapplicable : le volume dépasse le maximum permis",
  },
  {
    code: "REFUS8",
    statusCode: "X",
    name: "Collecte de branches inapplicable : branches contaminées",
  },
  {
    code: "REFUS9",
    statusCode: "X",
    name: "Collecte de branches inapplicable : présence de branches de conifères",
  },
  {
    code: "SUSP",
    statusCode: "N",
    name: null,
  },
  {
    code: "TERM1",
    statusCode: "T",
    name: "Les travaux demandés ont été réalisés",
  },
  {
    code: "TERM_LOT",
    statusCode: "O",
    name: "Les travaux demandés ont été réalisés",
  },
  {
    code: "TRAN",
    statusCode: "S",
    name: null,
  },
];
